const forms = document.querySelectorAll('form[novalidate]');

forms.forEach((form) => {
  const inputs: NodeListOf<HTMLInputElement> = form.querySelectorAll('input:not([type=hidden])');

  inputs.forEach((input) => {
    const inputGroup = input.parentNode;
    const inputError = inputGroup?.querySelector('.error');
    if (inputError) {
      let timer: number | undefined;
      input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (input.validity.valid) {
            inputError.textContent = '';
            inputError.classList.remove('tw:block');
          } else {
            if (input.validity.valueMissing) {
              inputError.textContent = Craft.t('js', '{input} is required', {
                input: input.placeholder,
              });
            } else if (input.type === 'email' && input.validity.typeMismatch) {
              inputError.textContent = Craft.t('js', '{input} must be a valid email address', {
                input: input.placeholder,
              });
            } else if (input.validity.tooShort) {
              inputError.textContent = Craft.t('js', '{input} must be at least {min} characters', {
                input: input.placeholder,
                min: input.minLength,
              });
            }

            if (inputError.textContent !== '' && !input.validity.valid) {
              inputError.classList.remove('tw:hidden');
              inputError.classList.add('tw:block');
            }
          }
        }, 500);
      });
    }
  });
});
